import { getFirestore, collection, getDocs, query, where } from "firebase/firestore";

const db = getFirestore();

export const getPracticeSessionQuestions = async (lessonId) => {
  try {
    const q = query(
      collection(db, "questions_new"),
      where("lessonid", "==", lessonId),
      where("active", "==", "0") // ✅ Fetch only inactive questions
    );

    const querySnapshot = await getDocs(q);
    const questions = querySnapshot.docs.map((doc) => doc.data());

    console.log(`✅ Fetched ${questions.length} questions for lessonId: ${lessonId}`);

    return questions;
  } catch (error) {
    console.error("❌ Error fetching practice session questions:", error);
    return [];
  }
};

